<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="constructionYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.constructionYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
            style="width: 100%"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="名称" prop="name">
          <a-input
            v-model="form.name"
            placeholder="请输入名称"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="类别" prop="type">
          <div class="flex">
            <a-select
              v-model="form.type"
              placeholder="请选择类别"
              :disabled="disabeld"
            >
              <a-select-option
                :value="item.text"
                v-for="item in jblist"
                :key="item.value"
                >{{ item.title }}</a-select-option
              >
            </a-select>
            <template v-if="form.type == '其他'">
              <a-input v-model="form.otherType" class="ipt-other" :disabled="disabeld" />
            </template>
          </div>
        </a-form-model-item>
        <a-form-model-item label="数量" prop="num">
          <a-input-number
            v-model="form.num"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入数量"
            :disabled="disabeld"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        constructionYear: "",
        name: "",
        type: "",
        num: "",
      },
      rules: {
        constructionYear: [
          {
            required: true,
            message: "请选择年份",
            validator: (rule, value, callback) => {
              if (this.form.constructionYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入品牌建设名称",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择品牌建设类别",
            trigger: "change",
          },
        ],
        num: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 2,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      disabeld: false,
    };
  },
  components: { BaseEditor },
  mounted() {},
  methods: {
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      // this.form.constructionYear = value;
      const year = moment(value).format("YYYY");
      this.form.constructionYear = year + "";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("constructionYear");
      // this.yearShowOne = false;
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.getxwlist();
      this.getcgjb();
      this.getkclist();
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.title = "新增品牌建设";
        this.form.constructionYear = new Date().getFullYear() + "";
      } else if (type == "edit") {
        this.title = "编辑品牌建设";
        this.form = {
          name: record.name,
          type: record.type,
          num: record.num,
          otherType: record.otherType,
          courseType: record.courseType,
          applyId: record.applyId,
          constructionYear: record.constructionYear,
          id: record.id,
          content: record.content,
        };
        if (record.amount == "1") {
          this.ifirst = true;
        } else {
          this.ifirst = false;
          this.form.content = "";
        }
        if (record.achievementType == "SZKC") {
          this.ishow = true;
        } else {
          this.ishow = false;
          this.form.courseType = "";
        }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      } else {
        this.disabeld = true;
        this.title = "查看品牌建设";
        this.form = {
          name: record.name,
          type: record.type,
          num: record.num,
          otherType: record.otherType,
          courseType: record.courseType,
          applyId: record.applyId,
          constructionYear: record.constructionYear,
          id: record.id,
          content: record.content,
        };
        if (record.amount == "1") {
          this.ifirst = true;
        } else {
          this.ifirst = false;
          this.form.content = "";
        }
        if (record.achievementType == "SZKC") {
          this.ishow = true;
        } else {
          this.ishow = false;
          this.form.courseType = "";
        }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=brand_build").then(
        (res) => {
          if (res.code == 200) {
            this.jblist = res.result;
          }
        }
      );
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.constructionYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      //  	this.$refs.ruleForm.clearValidate();
      console.log(typeof this.form.constructionYear);
      if (
        typeof this.form.constructionYear == "object" &&
        this.form.constructionYear != "" &&
        this.type == "add"
      ) {
        this.form.constructionYear =
          new Date(this.form.constructionYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = this.form;
            params.applyType = this.applyType;
            this.visible = false;
            this.$message.success("添加成功");
            this.$emit("addGain", { record: params, type: "add" });
            // postAction("/promotion/lxApplyConstruction/add", params).then(
            //   (res) => {
            //     if (res.code == 200) {
            //       this.visible = false;
            //       this.$message.success("添加成功");
            //       this.$emit("addGain");
            //     } else {
            //       this.$message.error(res.message);
            //     }
            //   }
            // );
          } else {
            let params = this.form;
            if (typeof this.form.constructionYear == "object") {
              params.constructionYear =
                new Date(this.form.constructionYear).getFullYear() + "";
            }
            params.applyType = this.applyType;
            this.visible = false;
            this.$message.success("编辑成功");
            this.$emit("addGain", { record: params, type: "edit" });
            // putAction("/promotion/lxApplyConstruction/edit", params).then(
            //   (res) => {
            //     if (res.code == 200) {
            //       this.visible = false;
            //       this.$message.success("编辑成功");
            //       this.$emit("addGain");
            //     } else {
            //       this.$message.error(res.message);
            //     }
            //   }
            // );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}
</style>
  